<template>
  <div v-if="isLoading" class="isLoadingDiv">
    <ProgressSpinner />
  </div>
  <div v-else-if="person" class="p-grid p-text-left">
    <div class="p-col-12 p-my-3">
      <h1 class="title is-1 displayInline">{{ person.name }}</h1>
      <Button
        class="p-button-outlined p-button-lg"
        style="float: right"
        :label="$t('Button.edit')"
        @click="goRouter(`/people/${person.id}/edit`)"
      />
    </div>
    <div class="p-col-12 paddedCol">
      <div class="rounded whiteBg paddedCol">
        <div class="p-mb-5">
          <div class="title is-5">{{ $t("roles") }}</div>
          <div class="title is-4 normalWeight">{{ personRoles }}</div>
        </div>
        <div class="p-mb-5">
          <div class="title is-5">{{ $t("primary-phone") }}</div>
          <div class="title is-4 normalWeight">
            {{ person.address.phone_primary || "None" }}
          </div>
        </div>
        <div class="p-mb-5">
          <div class="title is-5">{{ $t("secondary-phone") }}</div>
          <div class="title is-4 normalWeight">
            {{ person.address.phone_secondary || "None" }}
          </div>
        </div>
        <div class="p-mb-5">
          <div class="title is-5">{{ $t("PersonFrom.primary-email") }}</div>
          <div class="title is-4 normalWeight">
            {{ person.address.email_primary || "None" }}
          </div>
        </div>
        <div class="p-mb-5">
          <div class="title is-5">{{ $t("secondary-email") }}</div>
          <div class="title is-4 normalWeight">
            {{ person.address.email_secondary || "None" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      person: null,
      isLoading: true,
    };
  },
  computed: {
    personRoles() {
      var str = "";
      if (this.person.is_coach) {
        str += str ? this.$t("coach") : this.$t("coach");
      }
      if (this.person.is_player) {
        str += str ? this.$t("player") : this.$t("player");
      }
      if (this.person.is_staff) {
        str += str ? this.$t("staff") : this.$t("staff");
      }
      if (this.person.is_umpire) {
        str += str ? this.$t("umpire") : this.$t("umpire");
      }
      return str;
    },
  },
  methods: {
    getData() {
      api.getPerson(this.$route.params.person_id).then(response => {
        this.person = response.data;
        this.isLoading = false;
      });
    },
  },
  created() {
    this.getData();
  },
  watch: {
    "$route.params.person_id": function(id) {
      this.getData();
      window.analytics.page();
    },
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss"></style>
